// extracted by mini-css-extract-plugin
export default {"container":"style_container__Hg2BJ","page":"style_page__qWJdy","error":"style_error__DHtPz"};